<app-private-legal *ngIf="!accepted" (accept)="accepted = true"></app-private-legal>

<app-private-form *ngIf="accepted"></app-private-form>